<section class="w-full">
  <split-header-section title="Unidades">
    <button (click)="cadastrarUnidade()" class="btn-split btn-split-orange">
      CADASTRAR UNIDADE
    </button>
  </split-header-section>
  <div [style.padding-right]="'16.002px'" [style.padding-left]="'16.002px'" class="w-full">
    <split-card>
      <div card-header class="grid">
        <div class="col-3">
          <split-search class="hidden" placeholder="Pesquisar" (valueChange)="search($event)"></split-search>
        </div>
        <div class="col-9 flex justify-content-end align-items-center">
          <!-- <split-button-filter></split-button-filter> -->
          <div class="flex justify-center align-items-center mr-2">
            <label for="activeInactive mr-2 mb-2"> Inativos / Ativos </label>&nbsp;
            <p-inputSwitch id="activeInactive" [(ngModel)]="filter.isActive"
              (onChange)="setFilterActive()"></p-inputSwitch>
          </div>
          <split-button-filters [(filters)]="filters" (filtersChange)="setFilter($event)"></split-button-filters>
        </div>
      </div>
      <ng-container card-body>
        <div *ngIf="(unitState$ | async)?.type === 'loading' " class="flex align-items-center justify-content-center">
          <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
        </div>

        <split-table [widthColumns]="[20, 15, 15, 15, 15, 5, 5, 10]" *ngIf="(unitState$ | async)?.type != 'loading' "
          [filters]="filters" [checklist]="false" [dados]="filteredUnitList" theme="primary">
          <ng-template #header>
            <div class="pl-4">Unidade</div>
          </ng-template>
          <ng-template #coluna let-item="dadosLinha">
            <div class="pl-4" [ngClass]="!item.isActive? 'inativo': ''">
              <div class="text-left" [style.max-width]="'25rem'">
                <split-text [title]="item.unitName" [subtitle]="item.registrationNumber | formatCNPJ"></split-text>
              </div>
            </div>
          </ng-template>

          <ng-template #header>Tipo</ng-template>
          <ng-template #coluna let-item="dadosLinha">
            <div [ngClass]="!item.isActive? 'inativo': ''">
              {{ item.main ? "Matriz" : "Filial" }}
            </div>
          </ng-template>

          <ng-template #header>Telefone</ng-template>
          <ng-template #coluna let-item="dadosLinha">
            <div [ngClass]="!item.isActive? 'inativo': ''">
              {{ item.contactNumber | formatPhoneNumber }}
            </div>
          </ng-template>

          <ng-template #header>Endereço</ng-template>
          <ng-template #coluna let-item="dadosLinha">
            <div [ngClass]="!item.isActive? 'inativo': ''">
              <split-truncate-text max-width="15rem"
                [text]="item.address?.streetAddress + ', ' + item.address?.number"></split-truncate-text>
            </div>
          </ng-template>

          <ng-template #header>Cidade</ng-template>
          <ng-template #coluna let-item="dadosLinha">
            <div [ngClass]="!item.isActive? 'inativo': ''">
              <split-truncate-text max-width="15rem" [text]="item.address?.city"></split-truncate-text>
            </div>

          </ng-template>

          <ng-template #header>Split</ng-template>
          <ng-template #coluna let-item="dadosLinha">
            <div [ngClass]="!item.isActive? 'inativo': ''">

              <ng-container *ngIf="item.flagIssueInvoice == false">
                <i [pTooltip]="'Essa unidade não possui Split ativado'" style="color: #fbc02d"
                  class="pi pi-exclamation-circle"></i>
              </ng-container>

              <ng-container *ngIf="item.flagIssueInvoice == true">
                <ng-container *ngIf="item.flagUsesHeadOfficeTaxData == true">
                  <ng-container *ngIf=" item.mainUnit?.taxInfo?.statusRecipientExternal == 'active'">
                    <i [pTooltip]="'Cadastro Ativo'" style="color: #0a8300" class="pi pi-check-circle"></i>
                  </ng-container>
                  <ng-container *ngIf=" item.mainUnit?.taxInfo?.statusRecipientExternal != 'active'">
                    <i [pTooltip]="'Essa unidade utiliza dados fiscais da matriz, verifique o cadastro da matriz'"
                      style="color: #fbc02d" class="pi pi-exclamation-circle"></i>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="item.flagUsesHeadOfficeTaxData == false">
                  <ng-container *ngIf="item.taxInfo?.statusRecipientExternal != 'active'">
                    <i *ngIf="item.taxInfo?.statusRecipientExternal == 'pending'" [pTooltip]="'Pendente'"
                      style="color: #fbc02d" class="pi pi-spin pi-spinner"></i>
                    <i *ngIf="item.taxInfo?.statusRecipientExternal == 'registration'" [pTooltip]="'Pendente'"
                      style="color: #fbc02d" class="pi pi-spin pi-spinner"></i>
                    <i *ngIf="item.taxInfo?.statusRecipientExternal == 'affiliation'" [pTooltip]="'Pendente'"
                      style="color: #fbc02d" class="pi pi-spin pi-spinner"></i>
                    <i *ngIf="item.taxInfo?.statusRecipientExternal == 'refused'" [pTooltip]="'Cadastro Recusado'"
                      style="color: rgb(255, 3, 3)" class="pi pi-times"></i>
                    <i *ngIf="item.taxInfo?.statusRecipientExternal == 'suspended'"
                      [pTooltip]="'Cadastro Suspenso, o recebedor não fez o auto credenciamento'" style="color: #fbc02d"
                      class="pi pi-exclamation-circle"></i>
                    <i *ngIf="item.taxInfo?.statusRecipientExternal == 'blocked'" [pTooltip]="'Cadastro Bloqueado'"
                      style="color: rgb(255, 3, 3)" class="pi pi-ban"></i>
                    <i *ngIf="item.taxInfo?.statusRecipientExternal == 'inactive'" [pTooltip]="'Cadastro Inativo'"
                      style="color: rgb(255, 3, 3)" class="pi pi-exclamation-circle"></i>
                  </ng-container>

                  <ng-container *ngIf=" item.taxInfo?.statusRecipientExternal == 'active'">
                    <i [pTooltip]="'Cadastro Ativo'" style="color: #0a8300" class="pi pi-check-circle"></i>
                  </ng-container>
                </ng-container>
              </ng-container>
            </div>

            <!-- <div *ngIf="item.flagIssueInvoice && !item.flagUsesHeadOfficeTaxData" >
              <div class="w-2rem">
                <i *ngIf="item.taxInfo?.recipientActive" style="color: #0a8300" class="pi pi-check-circle"></i>
                <i *ngIf="item.taxInfo?.recipientActive == false" style="color: #fa0505"
                  class="pi pi-exclamation-circle" [pTooltip]="errorSplitTemplate"></i>

              </div>
            </div>

            <div *ngIf="item.flagIssueInvoice && item.flagUsesHeadOfficeTaxData" [ngClass]="!item.isActive? 'inativo': ''">
              <div class="w-2rem">
                <i *ngIf="item.mainUnit?.taxInfo?.recipientActive" style="color: #0a8300" class="pi pi-check-circle"></i>
                <i *ngIf="item.mainUnit?.taxInfo?.recipientActive == false" style="color: #fa0505"
                  class="pi pi-exclamation-circle" [pTooltip]="errorSplitTemplate"></i>

              </div>
            </div> -->

            <ng-template #errorSplitTemplate>
              <ul *ngIf="item.flagIssueInvoice && !item.flagUsesHeadOfficeTaxData" class="p-0 pl-4 pr-1">
                <li *ngIf="!item.taxInfo?.recipientActive">
                  Atualize seus Dados Bancários
                </li>
              </ul>

              <ul *ngIf="item.flagIssueInvoice && item.flagUsesHeadOfficeTaxData" class="p-0 pl-4 pr-1">
                <li *ngIf="!item.mainUnit?.taxInfo?.recipientActive">
                  Atualize os Dados Bancários da empresa Matriz
                </li>
              </ul>
            </ng-template>
          </ng-template>

          <ng-template #header>NF</ng-template>
          <ng-template #coluna let-item="dadosLinha">
            <div [ngClass]="!item.isActive? 'inativo': ''">
              <ng-container *ngIf="item.flagIssueInvoice == false">
                <i [pTooltip]="'Essa unidade não emite nota fiscal'" style="color: #fbc02d"
                  class="pi pi-exclamation-circle"></i>
              </ng-container>

              <ng-container *ngIf="item.flagIssueInvoice == true">
                <ng-container *ngIf="item.flagUsesHeadOfficeTaxData == true">

                  <ng-container
                    *ngIf="item.mainUnit?.taxInfo?.issuerPartnerId?.length > 0 && item.mainUnit?.taxInfo?.digitalCertificationFile?.length > 0">
                    <i [pTooltip]="'Cadastro Ativo'" style="color: #0a8300" class="pi pi-check-circle"></i>
                  </ng-container>
                  <ng-container
                    *ngIf="item.mainUnit?.taxInfo?.issuerPartnerId?.length <= 0 || item.mainUnit?.taxInfo?.digitalCertificationFile?.length <= 0">
                    <i [pTooltip]="'Essa unidade utiliza dados fiscais da matriz, verifique o cadastro da matriz'"
                      style="color: #fbc02d" class="pi pi-exclamation-circle"></i>
                  </ng-container>

                </ng-container>
                <ng-container *ngIf="item.flagUsesHeadOfficeTaxData == false">

                  <ng-container
                    *ngIf="item.taxInfo?.issuerPartnerId?.length > 0 && item.taxInfo?.digitalCertificationFile?.length > 0">
                    <i [pTooltip]="'Cadastro Ativo'" style="color: #0a8300" class="pi pi-check-circle"></i>
                  </ng-container>
                  <ng-container
                    *ngIf="item.taxInfo?.issuerPartnerId?.length <= 0 || item.taxInfo?.digitalCertificationFile?.length <= 0">
                    <i [pTooltip]="errorTemplate" style="color: #fbc02d" class="pi pi-exclamation-circle"></i>
                  </ng-container>

                </ng-container>

              </ng-container>
            </div>

            <!-- <div *ngIf="item.flagIssueInvoice && !item.flagUsesHeadOfficeTaxData" [ngClass]="!item.isActive? 'inativo': ''">
              <div class="w-2rem">
                <i *ngIf="item.taxInfo?.issuerPartnerId?.length && item.taxInfo?.digitalCertificationFile?.length"
                  style="color: #0a8300" class="pi pi-check-circle"></i>
                <i *ngIf="!item.taxInfo?.issuerPartnerId?.length || !item.taxInfo?.digitalCertificationFile?.length "
                  style="color: #fa0505" class="pi pi-exclamation-circle" [pTooltip]="errorTemplate"></i>
              </div>
            </div>

            <div *ngIf="item.flagIssueInvoice && item.flagUsesHeadOfficeTaxData" [ngClass]="!item.isActive? 'inativo': ''">
              <div class="w-2rem">
                <i *ngIf="item.mainUnit?.taxInfo?.issuerPartnerId?.length && item.mainUnit?.taxInfo?.digitalCertificationFile?.length"
                  style="color: #0a8300" class="pi pi-check-circle"></i>
                <i *ngIf="!item.mainUnit?.taxInfo?.issuerPartnerId?.length || !item.mainUnit?.taxInfo?.digitalCertificationFile?.length "
                  style="color: #fa0505" class="pi pi-exclamation-circle" [pTooltip]="errorTemplate"></i>
              </div>
            </div> -->
            <ng-template #errorTemplate>
              <ul class="p-0 pl-4 pr-1 my-1">
                <li *ngIf="item.taxInfo?.issuerPartnerId?.length <= 0">
                  Verifique os Dados Fiscais
                </li>
                <li class="my-1" *ngIf="item?.taxInfo?.digitalCertificationFile?.length <= 0">
                  Verifique o Certificado Digital
                </li>
              </ul>
            </ng-template>
          </ng-template>

          <!-- <ng-template #header>Prova de Vida</ng-template>
          <ng-template #coluna let-item="dadosLinha">
            <div [ngClass]="!item.isActive? 'inativo': ''">

              <ng-container  *ngIf="item.flagIssueInvoice == false">
                <i [pTooltip]="'Essa unidade não possui Split ativado, portanto não necessita prova de vida'"
                style="color: #fbc02d" class="pi pi-exclamation-circle"></i>
              </ng-container>

              <ng-container *ngIf="item.flagIssueInvoice == true">

                <ng-container *ngIf="item.flagUsesHeadOfficeTaxData == true">

                  <ng-container *ngIf="item.mainUnit?.taxInfo?.statusRecipientExternal != 'active'" >
                    <i [pTooltip]="'O cadastro da matriz ainda não está ativo'"
                  style="color: #fbc02d" class="pi pi-exclamation-circle"></i>
                  </ng-container>

                  <ng-container *ngIf=" item.mainUnit?.taxInfo?.statusRecipientExternal == 'active'">
                    <ng-container *ngIf="item.mainUnit?.taxInfo?.isProofActiveLife == true" >
                      <i [pTooltip]="'Cadastro Ativo'" style="color: #0a8300" class="pi pi-check-circle"></i>
                    </ng-container>
      
                    <ng-container *ngIf="item.mainUnit?.taxInfo?.isProofActiveLife == false">
                      <i [pTooltip]="'A matriz ainda não realizou a prova de vida'"
                    style="color: #fbc02d" class="pi pi-exclamation-circle"></i>
                    </ng-container>
                  </ng-container>


                </ng-container> 

                  <ng-container *ngIf="item.flagUsesHeadOfficeTaxData == false">

                    <ng-container *ngIf="item.taxInfo?.statusRecipientExternal != 'active'" >
                      <i [pTooltip]="'O cadastro ainda não está ativo'"
                    style="color: #fbc02d" class="pi pi-exclamation-circle"></i>
                    </ng-container>
      
                    <ng-container *ngIf=" item.taxInfo?.statusRecipientExternal == 'active'">
                      <ng-container *ngIf="item.taxInfo?.isProofActiveLife == true" >
                        <i [pTooltip]="'Cadastro Ativo'" style="color: #0a8300" class="pi pi-check-circle"></i>
                      </ng-container>
        
                      <ng-container *ngIf="item.taxInfo?.isProofActiveLife == false">
                        <p-button 
                          (onClick)="op.toggle($event)" 
                          icon="pi pi-exclamation-circle" 
                          [rounded]="true" 
                          [text]="true"
                          severity="danger" 
                        />
                        <p-overlayPanel #op (onHide)="onHideOverlayPanel()">
                          <div class="flex flex-column align-items-center w-16rem">
                            <span>Copiar link ou enviar por email</span>
                            <div class="p-inputgroup mt-3 w-15rem border-round-md" [style]="'border: 1px solid #BDBDBD !important;'">
                                <input 
                                  class="px-2 text-overflow-ellipsis" 
                                  type="text" 
                                  pInputText 
                                  readonly
                                  [value]="item.taxInfo?.proofLifeLink" 
                                />
                                <button
                                  class="h-2rem border-noround" 
                                  (click)="onCopyText(item.taxInfo?.proofLifeLink)"
                                  [style]="' background-color: #BDBDBD'" 
                                  type="button" 
                                  pButton 
                                  [icon]="copyButtonIcon"
                                ></button>
                            </div>
                    
                            <button 
                              (click)="onSubmitLinkByEmail(item.id)"
                              class="w-15rem mt-2 btn-split btn-split-orange h-2rem border-round-md"
                            > enviar link por email </button>
                          </div>
                        </p-overlayPanel>
                      </ng-container>
                    </ng-container>

                </ng-container>
              </ng-container>
            </div>
            
          </ng-template> -->

          <ng-template #header></ng-template>
          <ng-template #coluna let-item="dadosLinha">
            <div class="flex align-items-center pl-3">
              <div [ngClass]="!item.isActive? 'inativo': ''">
                <button (click)="editarUnidade(item)" pTooltip="Editar Unidade"
                  class="btn-split-icon btn-edit-default editar"></button>
              </div>

              <ng-template [ngIf]="item.isActive && !item.main">
                <button (click)="inativarUnidade(item)" pTooltip="Inativar Unidade"
                  class="btn-split-icon btn-block-primary"></button>
              </ng-template>

              <ng-template [ngIf]="!item.isActive && !item.main">
                <button class="action border-circle bg-white h-2rem" (click)="ativarUnidade(item)"
                  pTooltip="Ativar Unidade">
                  <img src="assets/cadastro/active.svg" alt="ativar Unidade" />
                </button>
              </ng-template>

              <!-- <button (click)="deletarUnidade(item.id)" pTooltip="Deletar Unidade" class="btn-split-icon btn-delete-danger"></button> -->
            </div>
          </ng-template>
        </split-table>
      </ng-container>
    </split-card>
  </div>


</section>

<!-- ---------------------------------------------- -->

<!-- dialog confirmação deletar / inativar -->

<!-- ---------------------------------------------- -->

<p-dialog [(visible)]="mostrarModalDeletar" [dismissableMask]="true" styleClass="pDialog" [draggable]="false"
  [modal]="true">
  <div class="content">
    <img src="assets/lista-unidade/modal-deletar/deletar-unidade.svg" alt="imagem deletar unidade" />
    <span class="title">
      <p>Tem certeza que deseja deletar</p>
      <p>essa Unidade?</p>
    </span>
    <span class="message">
      <p>Ao confirmar você excluirá permanentemente</p>
      <p>a unidade selecionada</p>
    </span>
  </div>
  <ng-template pTemplate="footer">
    <button class="cancelar" (click)="fecharDialog()">Cancelar</button>
    <button class="deletar" (click)="delete()">Deletar</button>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="mostrarModalInativar" [dismissableMask]="true" styleClass="pDialog" [draggable]="false"
  [modal]="true">
  <div class="content">
    <img src="assets/lista-unidade/modal-inativar/inativar-unidade.svg" alt="imagem deletar unidade" />
    <span class="title">
      <p>Tem certeza que deseja inativar</p>
      <p> essa Unidade?</p>
    </span>
    <span class="message">
      <p>Ao confirmar você inativará essa unidade da sua listagem</p>
      <p>padrão.</p>
    </span>
  </div>
  <ng-template pTemplate="footer">
    <button class="cancelar" (click)="fecharDialog()">Cancelar</button>
    <button class="inativar" (click)="inativarUnidadePatch()">Inativar</button>
  </ng-template>
</p-dialog>


<p-dialog [(visible)]="mostrarModalAtivar" [dismissableMask]="true" styleClass="pDialog" [draggable]="false"
  [modal]="true">
  <div class="content">
    <img src="assets/cadastro/active_modal.svg" alt="imagem deletar unidade">
    <span class="title">
      <p>Tem certeza que deseja ativar</p>
      <p>essa Unidade?</p>
    </span>
    <span class="message">
      <p>Ao confirmar você irá ativar essa unidade na sua listagem</p>
      <p>padrão</p>
    </span>
  </div>
  <ng-template pTemplate="footer">
    <button class="cancelar" (click)="fecharDialog()">Cancelar</button>
    <button class="ativar" (click)="ativarUnidadePatch()">Ativar</button>
  </ng-template>

</p-dialog>